import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_reminder",
  "use": "micro_reminder-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_reminder\"><g fill-rule=\"evenodd\"><path fill-rule=\"nonzero\" d=\"M1 8V4a4 4 0 1 1 8 0v4H7a2 2 0 1 1-4 0H1Zm5 0H4l.007.117A1 1 0 0 0 6 8ZM5 1a3 3 0 0 0-3 3v3h6V4a3 3 0 0 0-2.824-2.995L5 1Z\" /><path d=\"M0 7h10v1H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol